import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { FIELDS_PALETTE_GROUPS, type Tile, TILES } from './tiles';
import { Button } from 'framework/ui/mui-builder';
import { useTileDrag } from '../drag-and-drop';
import { useState } from 'react';
import { Draggable } from 'framework/dnd';

export const FieldsPalette = ({ onAdd }: { onAdd: (tile: Tile) => void }) => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: 0,
        borderRadius: '8px 0',
        backgroundColor: 'background.paper',
      }}
    >
      <Stack useFlexGap spacing={2} sx={{ p: 3 }}>
        {FIELDS_PALETTE_GROUPS.map(group => (
          <Stack useFlexGap key={group} component="section" aria-label={group} spacing={1}>
            <Typography
              variant="subtitle1"
              component="h3"
              color="brand"
              sx={{ pb: 0.5, borderBottom: 1, borderColor: 'primary.light' }}
            >
              {group}
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                gridAutoRows: '1fr',
                gap: 1,
              }}
            >
              {TILES.filter(tile => tile.group === group).map(tile => (
                <PaletteTile key={tile.name} tile={tile} onAdd={onAdd} />
              ))}
            </Box>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

const PaletteTile = ({ tile, onAdd }: { tile: Tile; onAdd: (tile: Tile) => void }) => {
  const drag = useTileDrag(tile);
  const [tooltip, setTooltip] = useState(false);
  const Icon = tile.icon;
  return (
    <Draggable initialData={drag} params={{ onDrop: () => setTooltip(false) }}>
      {({ isDragging }) => (
        <Tooltip
          title={tile.tooltip}
          describeChild
          placement="top"
          enterDelay={400}
          enterNextDelay={200}
          open={tooltip && !isDragging}
          onOpen={() => setTooltip(true)}
          onClose={() => setTooltip(false)}
        >
          <Button
            variant="outlined"
            fullWidth
            startIcon={<Icon />}
            onClick={() => onAdd(tile)}
            sx={{
              height: '100%',
              minWidth: 0,
              px: 0,
              cursor: 'grab',
            }}
          >
            {tile.name}
          </Button>
        </Tooltip>
      )}
    </Draggable>
  );
};
